<div *ngIf="{ vehicleDropdowns: vehicleDropdowns$ | async } as data;">

  <form fxLayout="row wrap" fxLayoutAlign="start center" [formGroup]="vehicleForm" novalidate>
    <ng-template>Vehicle</ng-template>
    <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="33">
      <mat-form-field appearance="fill">
        <mat-label>Vin</mat-label>
        <input id="vehicleFormVin" matInput formControlName="vin" oninput="this.value = this.value.toUpperCase()">
        <mat-error *ngIf="vehicleForm.get('vin').errors">
          {{vehicleForm.get('vin').errors | inputError}}
        </mat-error>
        <mat-hint [ngSwitch]="vinError">
          <span *ngSwitchCase="'vinCheckDigitFailed'">Vin does not pass Check Digit validation and may be
            invalid.</span>
          <span *ngSwitchCase="'vinLengthFailed'">Vin is less than 17 characters and may be invalid.</span>
        </mat-hint>
      </mat-form-field>
    </div>
    <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="33">
      <mat-form-field appearance="fill">
        <mat-label>Trim</mat-label>
        <mat-select formControlName="trimLevel">
          <mat-option *ngFor="let trim of trims" [value]="trim.trim">
            {{trim.trim}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="33">
      <mat-form-field appearance="fill">
        <mat-label>Sub-Type</mat-label>
        <mat-select formControlName="subTypeId">
          <mat-option *ngFor="let subType of data.vehicleDropdowns.subTypes" [value]="subType.id"
            (click)="setVehicleType(subType)">
            {{subType.description}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="33">
      <mat-form-field appearance="fill">
        <mat-label>Year</mat-label>
        <input id="year" type="number" matInput formControlName="year">
      </mat-form-field>
    </div>

    <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="33">
      <mat-form-field appearance="fill">
        <mat-label>Make</mat-label>
        <mat-select formControlName="make">
          <mat-option *ngFor="let make of data.vehicleDropdowns.makes" [value]="make.description">
            {{make.description}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="33">
      <mat-form-field appearance="fill">
        <mat-label>Model</mat-label>
        <input id="model" matInput formControlName="model">
      </mat-form-field>
    </div>

    <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="33">
      <mat-form-field appearance="fill">
        <mat-label>Body</mat-label>
        <input #vehicleBody matInput autocomplete="vehicleBody" id="vehicleBody" aria-label="Body"
          [matAutocomplete]="vehicleBodyAuto" formControlName="body">
        <mat-autocomplete #vehicleBodyAuto="matAutocomplete" autocomplete="vehicleBody">
          <mat-option *ngFor="let body of bodyDropdowns$ | async" [value]="body.vehicleBody">
            <span>{{body.vehicleBody}}</span>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="33">
      <mat-form-field appearance="fill">
        <mat-label>Engine</mat-label>
        <input id="engine" matInput formControlName="engine">
      </mat-form-field>
    </div>

    <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="33">
      <mat-form-field appearance="fill">
        <mat-label>Plate Number</mat-label>
        <input id="licensePlateNumber" matInput formControlName="licensePlateNumber" oninput="this.value = this.value.toUpperCase()">
      </mat-form-field>
    </div>

    <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="33">
      <mat-form-field appearance="fill">
        <mat-label>Current Mileage</mat-label>
        <input id="currentMileage" type="number" matInput formControlName="currentMileage">
      </mat-form-field>
    </div>

    <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="33">
      <mat-form-field appearance="fill">
        <mat-label>Prospect Colour</mat-label>
        <mat-select formControlName="prospectColourId">
          <mat-option *ngFor="let colour of data.vehicleDropdowns.colours" [value]="colour.id">
            {{colour.colourDescription}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="form-field" fxLayout="row" fxLayoutAlign="center center" fxFlex.sm="33" fxFlex.gt-sm="33">
      <mat-form-field appearance="fill">
        <mat-label>In-Service Date</mat-label>
        <input formControlName="deliveryDate" matInput [matDatepicker]="picker" [max]="maxInServiceDate">
        <mat-error *ngIf="vehicleForm.get('deliveryDate').errors">
          {{vehicleForm.get('deliveryDate').errors | inputError}}
        </mat-error>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
  </form>


</div>
